/*
 * File: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice\src\Content\HomePage\HomePage.tsx
 * Project: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice
 * Created Date: Wednesday June 7th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday, 11th October 2023 01:49:04
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import RouterPathResolver from "Config/Router/RouterPathResolver";
// import ModalPack from "Content/Modals/ModalPack/ModalPack";
// import ModalSell from "Content/Modals/ModalSell/ModalSell";
// import ModalUser from "Content/Modals/ModalUser/ModalUser";
import Table from "Content/Table/Table";
import translator from "MultiLanguage/TranslationWrapper";
import { MouseEventHandler, useEffect, useMemo, useState } from "react";
import { Link, NavigateFunction, useLoaderData, useNavigate } from "react-router-dom";
import homePageInfo, { CarsIntels, UserIntels } from "Type/homePageInfo.type";
import TableUtils from "Utils/TableFormat";
// import PostItDisplay from "Content/HomePage/PostItDisplay";
import { DataInfo, GlobalUsageIntel } from "Type/dataInfo";
import Style from "Content/HomePage/HomePage.module.css";
import { useAuth } from "Router/AuthProvider";
// import HomeService from "Services/Home/HomeService";
import { TipimailInfo } from "Type/Email.type";
import ModalAddCar from "Content/Modals/ModalAddCar/ModalAddCar";
import { TableCell, TableRow } from "@mui/material";
import PostItDisplay from "./PostItDisplay";
// import TextEditor from "Content/TextEditor/TextEditor";

const buildMyRowsUsers = (usersInfo: UserIntels, handleCreateUser: MouseEventHandler, navigate: NavigateFunction) => {
    const styling = {width:`${100/7}%`};
    return [<TableRow key={`row-user`} onClick={() => navigate(RouterPathResolver.pathUser.path)}>
        <TableCell style={styling} key={`row-user-title`}>{translator.decode(`dynamic.users`)}</TableCell>
        <TableCell style={styling} key={`row-user-total`}>{usersInfo.total}</TableCell>
        <TableCell style={styling} key={`row-user-new`}>{usersInfo.newUser}</TableCell>
        <TableCell style={styling} key={`row-user-pending`}>{usersInfo.pendingUser}</TableCell>
        <TableCell style={styling} key={`row-user-valid`}>{usersInfo.validUser}</TableCell>
        <TableCell style={styling} key={`row-user-archived`}>{usersInfo.archivedUser}</TableCell>
        {/* <TableCell style={styling} key={`row-user-action`}><button onClick={ handleCreateUser } className="btn btn-primary">{translator.decode("dynamic.create")}</button> </TableCell> */}
    </TableRow>];
};

const buildMyRows = (data: CarsIntels, handleAddCar: MouseEventHandler, navigate: NavigateFunction, handleSynchroCar: MouseEventHandler) => {
    const styling = {width:`${75/6}%`};
    return [<TableRow key={`row-carinfo`} onClick={() => navigate(data.path)}>
        <TableCell style={styling}>{translator.decode(`dynamic.${data.title}`)}</TableCell>
        <TableCell style={styling}>{data.total}</TableCell>
        <TableCell style={styling}>{data.selling}</TableCell>
        <TableCell style={styling}>{data.sold}</TableCell>
        <TableCell style={styling}>{data.reserved}</TableCell>
        <TableCell style={styling}>{data.archived}</TableCell>
        <TableCell style={{width:`25%`}} key={`row-user-action`}>
            {/* <button onClick={ handleAddCar } className="btn btn-primary me-3">{translator.decode("dynamic.add")}</button> */}
            <button onClick={handleAddCar} className="btn btn-primary">{translator.decode("dynamic.newCarTemplate")}</button>
        </TableCell>
    </TableRow>];
};

const buildStats = (data: GlobalUsageIntel, navigate: NavigateFunction) => {
    return [<TableRow key={`row-connexion`} style={{cursor: "cursor"}} onClick={() => navigate(`${RouterPathResolver.pathStats.path}?tabkey=connexion`)}>
                <TableCell key={`row-connexion-title`}><span>{translator.decode("home.connexion")}</span></TableCell>
                <TableCell key={`row-connexion-today`}><span className={`${Style.boldText} text-success`}>{data.connexions.today.success}</span>/<span className={`${Style.boldText} text-danger`}>{data.connexions.today.failed}</span></TableCell>
                <TableCell key={`row-connexion-thisWeek`}><span className={`${Style.boldText} text-success`}>{data.connexions.thisWeek.success}</span>/<span className={`${Style.boldText} text-danger`}>{data.connexions.thisWeek.failed}</span></TableCell>
                <TableCell key={`row-connexion-thisMonth`}><span className={`${Style.boldText} text-success`}>{data.connexions.thisMonth.success}</span>/<span className={`${Style.boldText} text-danger`}>{data.connexions.thisMonth.failed}</span></TableCell>
        </TableRow>,
        <TableRow key={`row-seenCars`} style={{cursor: "cursor"}} onClick={() => navigate(`${RouterPathResolver.pathStats.path}?tabkey=seencar`)}>
            <TableCell key={`row-seenCar-title`}><span>{translator.decode("home.seenCar")}</span></TableCell>
            <TableCell key={`row-seenCar-today`}><span>{data.seenCars.today}</span></TableCell>
            <TableCell key={`row-seenCar-thisWeek`}><span>{data.seenCars.thisWeek}</span></TableCell>
            <TableCell key={`row-seenCar-thisMonth`}><span>{data.seenCars.thisMonth}</span></TableCell>
        </TableRow>,
        <TableRow key={`row-offers`} style={{cursor: "cursor"}} onClick={() => navigate(`${RouterPathResolver.pathStats.path}?tabkey=offer`)}>
            <TableCell key={`row-offer-title`}><span>{translator.decode("home.offer")}</span></TableCell>
            <TableCell key={`row-offer-today`}><span>{data.offers.today}</span></TableCell>
            <TableCell key={`row-offer-thisWeek`}><span>{data.offers.thisWeek}</span></TableCell>
            <TableCell key={`row-offer-thisMonth`}><span>{data.offers.thisMonth}</span></TableCell>
        </TableRow>,
        <TableRow key={`row-email`} style={{cursor: "cursor"}} onClick={() => navigate(`${RouterPathResolver.pathStats.path}?tabkey=email`)}>
            <TableCell key={`row-email-title`}><span>{translator.decode("home.email")}</span></TableCell>
            <TableCell key={`row-email-today`}><span>{buildEmailStats(data.email.day)}</span></TableCell>
            <TableCell key={`row-email-thisWeek`}><span>{buildEmailStats(data.email.week)}</span></TableCell>
            <TableCell key={`row-email-thisMonth`}><span>{buildEmailStats(data.email.month)}</span></TableCell>
        </TableRow>];
};

const buildEmailStats = (data: TipimailInfo) => {
    const errorSum = data.error + data.softbounced + data.hardbounced + data.rejected;
    return <div>
        <span>{TableUtils.Spliting(data.delivered)}</span> / <span style={{color: "green"}}>{TableUtils.Spliting(data.opener)}</span> / <span style={{color: "red"}}>{TableUtils.Spliting(errorSum)}</span>
    </div>;
};

function HomePage(_: any) {
    const navigate = useNavigate();
    // const loadData = useLoaderData() as homePageInfo;
    const loadData = useLoaderData() as Promise<any>[];
    const [myUsageData, setMyUsageData] = useState<JSX.Element[]>([]);
    const translateKey = "home.headers.";
    const keysCars = ["title", "total", "selling", "sold", "reserved", "archived", "action"];
    const keysUser = ["title", "total", "new", "pending", "valid", "archived", "action"];
    const keysUsage = ["title", "today", "thisWeek", "thisMonth"];
    const dataTableCars = TableUtils.initFormatRowCreateHeader(keysCars, translateKey);
    const dataTableUser = TableUtils.initFormatRowCreateHeader(keysUser, translateKey);
    const dataTableUsage = TableUtils.initFormatRowCreateHeader(keysUsage, translateKey);
    const [showModalCar, setShowModalCar] = useState(false);
    const [archive, setArchive] = useState(false);
    const [showModalUser, setShowModalUser] = useState(false);

    const [userInfos, setUserInfos] = useState({
        total: 0,
        newUser: 0,
        validUser: 0,
        pendingUser: 0,
        archivedUser: 0
    });
    const [carInfos, setCarInfos] = useState({
        title: "",
        path: "",
        total: 0,
        selling: 0,
        reserved: 0,
        sold: 0,
        archived: 0
    });

    useEffect(() => {
        Promise.all(loadData).then(result => {
            setUserInfos(result[0]);
            setCarInfos(result[1]);
        });
    }, []);

    const handleAddCar = (e: any) => {
        e.stopPropagation();
        setShowModalCar(true);
        setArchive(false);
    };
    const handleSynchroCar = (e: any) => {
        e.stopPropagation();
        setShowModalCar(true);
        setArchive(true);
    };

    const handleToggleCarModal = (e: React.MouseEvent<HTMLElement>) => {
        setShowModalCar(false);
    };

    const handleCreateUser = (e: any) => {
        e.stopPropagation();
        setShowModalUser(true);
    };

    // useEffect(() => {
    //     HomeService.getUsageInfo(logout).then((usageData) => {
    //         setMyUsageData(buildStats(usageData, navigate));
    //     }).catch(()=> {
    //         console.error(`Unable to load usage data`);
    //     });
    // }, []);

    const userIntels = useMemo(() => {
        return buildMyRowsUsers(userInfos, handleCreateUser, navigate);
    }, [userInfos]);

    const carIntels = useMemo(() => {
        return buildMyRows(carInfos, handleAddCar, navigate, handleSynchroCar);
    }, [carInfos]);

    return(
        <div className={`${Style.homePage}`}>
            <div className={`${Style.tables}`}>
                <div>
                    <h2>{translator.decode("home.users")}</h2>
                    <Table className={`${Style.table}`} rows={userIntels} header={dataTableUser.header} nbTotalElement={0} pagination={false} />
                </div>
                {/* <div>
                    <h2>{translator.decode("home.stats")}</h2>
                    <Table className={`${Style.table}`} rows={myUsageData} header={dataTableUsage.header} nbTotalElement={0} pagination={false} />
                </div> */}
                <div>
                    <h2>{translator.decode("home.cars")}</h2>
                    <Table className={`${Style.table}`} rows={carIntels} header={dataTableCars.header} nbTotalElement={0} pagination={false} />
                </div>
            </div>
            <PostItDisplay />
            <ModalAddCar title={translator.decode("dynamic.newCarTemplate")} show={showModalCar} onClose={handleToggleCarModal} closeModal={handleToggleCarModal} />
        </div>
    );
};

export default HomePage;
